import { useNavigate } from 'react-router-dom';
import { BookOpen, DollarSign, ClipboardList, HelpCircle, CheckSquare, ArrowRight } from 'lucide-react';

const RESOURCES = [
  { icon: BookOpen, title: 'Career Planning Guide', body: 'The 20-minute read that has helped 500+ Canadians pick a career direction they don\u2019t regret.' },
  { icon: DollarSign, title: 'Funding Basics', body: 'What loans, grants and employer sponsorships actually cost you.' },
  { icon: ClipboardList, title: 'Program Comparison Tool', body: 'See two programs side-by-side, outcomes included.' },
  { icon: HelpCircle, title: 'Questions to Ask a College', body: "A checklist so you're not caught off-guard on your info call." },
  { icon: CheckSquare, title: 'Education Planning Checklist', body: 'From transcripts to first-day prep — everything in order.' },
];

export default function ResourcesPage() {
  const navigate = useNavigate();
  return (
    <div className="bg-brand-alabaster font-sans-clean text-brand-obsidian" data-testid="resources-page">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-24 pb-16">
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-pine font-bold mb-4">Resources</div>
        <h1 className="font-serif-editorial text-5xl md:text-6xl leading-[1.05] tracking-tight">
          Useful things, <span className="text-brand-pine italic">before you commit.</span>
        </h1>
        <p className="mt-8 text-lg text-brand-slate leading-relaxed max-w-2xl">
          We&apos;d rather you have the facts than a sales pitch. Read, download, decide — on your own timeline.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {RESOURCES.map((r, i) => (
            <div key={r.title} className="bg-white border border-brand-border/50 rounded-2xl p-7 hover:-translate-y-1 hover:border-brand-pine/40 transition-[transform,border-color] cursor-pointer" data-testid={`resource-card-${i}`}>
              <div className="w-11 h-11 rounded-xl bg-brand-pine/5 flex items-center justify-center">
                <r.icon size={20} className="text-brand-pine" />
              </div>
              <h3 className="font-serif-editorial text-xl mt-6 leading-snug">{r.title}</h3>
              <p className="text-sm text-brand-slate mt-3 leading-relaxed">{r.body}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-sm text-brand-pine font-semibold">
                Coming soon <ArrowRight size={14} />
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-brand-pine text-white">
        <div className="max-w-4xl mx-auto px-6 py-24 text-center">
          <h2 className="font-serif-editorial text-3xl md:text-5xl leading-tight">Would you rather just talk to someone?</h2>
          <button
            onClick={() => navigate('/contact')}
            data-testid="resources-cta"
            className="mt-8 inline-flex items-center gap-2 bg-brand-coral hover:bg-brand-coral-deep text-white text-sm font-semibold px-8 py-4 rounded-full transition-colors"
          >
            Book a Free Consultation <ArrowRight size={16} />
          </button>
        </div>
      </section>
    </div>
  );
}
